export default __webpack_public_path__ + "static/media/Dental_bridge.8a564ae7.jpg";